<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2313567" style="color: #82a339"><b>SOUTH-OF-THE-BORDER <br/> CHICKEN SOUP</b></p>
<p class="txc" id="d7e2314367"><a href="#/Text/West_9781618371621_epub_c44_r1#d7e1508450" id="d14e6245"> (Pictured) </a></p>
<p class="ext" id="d7e2314867"><b><i>We give this rich homemade soup a Latin accent with lime and cilantro, and serve it with chunks of buttery avocado and crisp tortilla chips.</i></b></p>
<p class="h4" id="d7e2316167" style="color: #496210"><b>Prep: 25 minutes Cook: 1 hour</b></p>
<p class="ul" id="d7e2316667">8 medium all-purpose potatoes (2½ pounds)</p>
<p class="ul" id="d7e2317767">1 chicken (4 pounds), cut into 8 pieces</p>
<p class="ul" id="d7e2318067">3 large stalks celery, each cut into thirds</p>
<p class="ul" id="d7e2318367">3 carrots, peeled and each cut into thirds</p>
<p class="ul" id="d7e2318767">2 medium onions, not peeled, each <br/> cut into quarters</p>
<p class="ul" id="d7e2319367">10 cups water</p>
<p class="ul" id="d7e2319667">10 sprigs plus ¼ cup chopped fresh cilantro</p>
<p class="ul" id="d7e2320867">2 bay leaves</p>
<p class="ul" id="d7e2321467">1 teaspoon whole black peppercorns</p>
<p class="ul" id="d7e2321767">1 can (15¼ to 16 ounces) whole-kernel corn, drained</p>
<p class="ul" id="d7e2322967">2 teaspoons salt</p>
<p class="ul" id="d7e2323267">¼ cup fresh lime juice (about 2 large limes)</p>
<p class="ul" id="d7e2324167">2 ripe medium avocados, cut into ½-inch pieces <br/> tortilla chips <br/> lime wedges</p>
<p class="pub" id="d7e2326267" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Peel 3 potatoes. In 8-quart Dutch oven, combine chicken, peeled potatoes, celery, carrots, onions, water, cilantro sprigs, bay leaves, and peppercorns; heat to boiling over high heat. Reduce heat; cover and simmer until chicken loses its pink color throughout and vegetables are tender, 35 to 45 minutes. Transfer chicken and potatoes to separate bowls.</p>
<p class="pub" id="d7e2329067"><span style="color: #c15b49"><b>2.</b></span> Strain broth through sieve into large bowl; discard vegetables. Skim and discard fat from broth; return broth to same clean Dutch oven. Mash cooked potatoes with 1 cup broth; stir mashed-potato mixture into broth in Dutch oven.</p>
<p class="pub" id="d7e2331467"><span style="color: #c15b49"><b>3.</b></span> Peel and chop remaining 5 potatoes. Add potatoes to broth; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, about 10 minutes.</p>
<p class="pub" id="d7e2333367"><span style="color: #c15b49"><b>4.</b></span> Meanwhile, discard skin and bones from chicken; cut chicken into bite-size pieces. Stir chicken, corn, and salt into broth; heat through.</p>
<p class="pub" id="d7e2335167"><span style="color: #c15b49"><b>5.</b></span> Just before serving, stir lime juice and chopped cilantro into soup. Serve with avocado, tortilla chips, and lime wedges. Makes about 16 cups or 8 main-dish servings.</p>
<p class="ntx" id="d7e2336967">Each serving without garnishes: About 344 calories, 28g protein, 34g carbohydrate, 12g total fat (2g saturated), 76mg cholesterol, 772mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c69_r1.vue?01126424